import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faPlay,
  faUpRightFromSquare,
  faCopy,
  faShareNodes,
} from '@fortawesome/free-solid-svg-icons';
import './GeoGuessSetup.css';

interface Props {
  gameId: string;
  gameTitle: string;
  scope: string;
  rounds: number;
  difficulty: string;
  timePerRound: number;
}

const GeoPublish: React.FC<Props> = ({
  gameId,
  gameTitle,
  scope,
  rounds,
  difficulty,
  timePerRound,
}) => {
  const navigate = useNavigate();
  const gameCode = String(gameId).toUpperCase();
  const [copied, setCopied] = useState(false);
  const [inviteEmail, setInviteEmail] = useState('');
  const [invitedPlayers] = useState([]); // replace with API

  const copyCode = () => {
    const baseUrl =
      process.env.REACT_APP_FRONTEND_URL || window.location.origin;
    const url = `${baseUrl}/join?gameId=${gameCode}`;
    navigator.clipboard.writeText(url);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="geo-pub">
      {/* Banner */}
      <div className="geo-pub__banner">
        <span className="geo-pub__banner-emoji">🎉</span>
        <div className="geo-pub__banner-text">
          <h2>Your game is ready!</h2>
          <p>Where is this? · {scope} · Geo Guess</p>
        </div>
        <div className="geo-pub__banner-actions">
          <button
            className="geo-pub__btn geo-pub__btn--primary"
            onClick={() => navigate(`/dashboard/games/game/${gameId}/lobby`)}
          >
            <FontAwesomeIcon icon={faPlay} /> Host Lobby
          </button>
          <button
            className="geo-pub__btn geo-pub__btn--outline"
            onClick={() => navigate('/dashboard/games')}
          >
            <FontAwesomeIcon icon={faUpRightFromSquare} /> My Games
          </button>
        </div>
      </div>

      <div className="geo-pub__body">
        {/* Left: Game code */}
        <div className="geo-pub__code-card">
          <span className="geo-pub__code-label">GAME CODE</span>
          <h1 className="geo-pub__code">{gameCode}</h1>
          <p className="geo-pub__code-sub">
            Share this code with players to join
          </p>
          <button
            className="geo-pub__btn geo-pub__btn--dark geo-pub__btn--full"
            onClick={copyCode}
          >
            <FontAwesomeIcon icon={faCopy} /> {copied ? 'Copied!' : 'Copy Code'}
          </button>
          <button className="geo-pub__btn geo-pub__btn--primary geo-pub__btn--full">
            <FontAwesomeIcon icon={faShareNodes} /> Share Invite Link
          </button>
        </div>

        {/* Right */}
        <div className="geo-pub__right">
          {/* Stats */}
          <div className="geo-pub__stats">
            <div className="geo-pub__stat">
              <span className="geo-pub__stat-val">{rounds}</span>
              <span className="geo-pub__stat-lbl">Rounds</span>
            </div>
            <div className="geo-pub__stat">
              <span className="geo-pub__stat-val">{difficulty}</span>
              <span className="geo-pub__stat-lbl">Difficulty</span>
            </div>
            <div className="geo-pub__stat">
              <span className="geo-pub__stat-val">{timePerRound * 60}s</span>
              <span className="geo-pub__stat-lbl">Time/Round</span>
            </div>
          </div>

          {/* Invite */}
          <div className="geo-pub__invite">
            <div className="geo-pub__invite-header">
              <h4>Invite Players</h4>
              <span className="geo-pub__invite-count">
                👥 {invitedPlayers.length} invited
              </span>
            </div>
            <div className="geo-pub__invite-row">
              <input
                className="geo-pub__input"
                type="text"
                placeholder="Search by username or email..."
                value={inviteEmail}
                onChange={(e) => setInviteEmail(e.target.value)}
              />
              <button className="geo-pub__btn geo-pub__btn--primary">
                Invite
              </button>
            </div>
            <div className="geo-pub__invited-grid">
              {invitedPlayers.map((p) => (
                <div key={p.name} className="geo-pub__invited-card">
                  <span className="geo-pub__invited-icon">{p.icon}</span>
                  <span className="geo-pub__invited-name">{p.name}</span>
                  <span className="geo-pub__invited-dot" />
                </div>
              ))}
            </div>
          </div>

          {/* QR */}
          <div className="geo-pub__qr">
            <div className="geo-pub__qr-icon">📱</div>
            <div className="geo-pub__qr-text">
              <h4>Share via QR Code</h4>
              <p>Players can scan to join instantly</p>
            </div>
            <button className="geo-pub__btn geo-pub__btn--outline">
              Generate QR
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GeoPublish;
